import styled from '@emotion/styled';

const PanelFooter = styled('div')`
  border-top: 1px solid ${p => p.theme.border};
  color: ${p => p.theme.subText};
  font-size: 14px;
`;

export default PanelFooter;
